import { useFragment } from '@apollo/client/react';
import { plural, t } from '@lingui/core/macro';
import { AvatarList, AvatarWithLabel, Box, UserAvatar } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { AccessManagementOwnersFragmentDoc } from './AccessManagementOwners.gql';
export function AccessManagementOwners(props) {
    const { from } = props;
    const { data, complete } = useFragment({
        from,
        fragment: AccessManagementOwnersFragmentDoc,
    });
    if (!complete) {
        return null;
    }
    const getName = (name) => name || t({ message: 'Deleted user', comment: 'Unknown user name' });
    const ownersCount = data.owners.length;
    return (<Box p="md" gap="md" borderRadius="md" bg="background.75" alignItems="center" justifyContent="space-between">
      <AvatarWithLabel size="md" appearance="light" truncate={false} title={t({
            message: 'Owners',
            comment: 'Access management - Owners title',
        })} subtitle={plural(ownersCount, {
            one: '# owner have access in addition to the permissions listed below.',
            other: '# owners have access in addition to the permissions listed below.',
        })}>
        <Falcon icon="user"/>
      </AvatarWithLabel>
      <AvatarList>
        {data.owners.map((owner) => {
            var _a, _b;
            return (<UserAvatar key={owner.id} title={getName((_a = owner.user) === null || _a === void 0 ? void 0 : _a.name)} subtitle={((_b = owner.user) === null || _b === void 0 ? void 0 : _b.email) || ''}/>);
        })}
      </AvatarList>
    </Box>);
}
